import React, { useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import {
  getLocalStorage,
  removeLocalStorage,
  setLocalStorage,
} from "../utils/storageUtil";
import config from "../config/config";
import { isLoggedIn } from "../utils/helperFunctions";
import apiList from "../services/apiList";
import { callApi } from "../services/callApi";

const CartContext = React.createContext();

const CartProvider = (props) => {
  const [cookies, setCookie] = useCookies(["cart"]);
  const [cart, setCart] = useState(getLocalStorage("cart") || {});

  useEffect(() => {
    setLocalStorage("cart", cart);
    console.log("change in cart", cart);
  }, [cart]);

  function set(cartObj) {
    let obj = JSON.parse(JSON.stringify(cartObj));
    setCart(obj);
    setCookie("cart", JSON.stringify(obj), {
      path: "/",
    });
    console.log("set cart", obj);
  }

  function reset() {
    setCart({});
    removeLocalStorage("cart");
    setCookie("cart", JSON.stringify(cart), {
      path: "/",
    });
  }

  function addItem(params) {
    const storeId = params.storecode;
    const storeNm = params.storename;

    const movementType = params?.movementType;
    const sector = params?.sector;
    const terminal = params?.terminal;
    const fulfilmentType = params?.fulfilmentType;

    let newItem = params.item;
    if (!newItem.deliveryOptions) {
      newItem.deliveryOptions = {};
    }

    let cartObj = cart;

    if (cartObj) {
      if (void 0 === cartObj[storeId]) {
        cartObj[storeId] = {
          storeId,
          storeNm,
          movementType,
          sector,
          terminal,
          fulfilmentType,
          items: [],
          metadata: params.metadata || null,
        };
      }
      if (!this.hasItem(params)) {
        cartObj[storeId].items.push(newItem);
      }
      this.set(cartObj);
      setCookie("cart", JSON.stringify(cart), {
        path: "/",
      });

      return true;
    } else {
      this.reset();
      return false;
    }
  }

  function removeItem(params) {
    const storeId = params.storecode;
    let addOnFlag = false;
    let preferenceFlag = false;

    if (cart && cart[storeId]) {
      cart[storeId].items = cart[storeId].items.filter((x) => {
        if (x.itemId === params.productId) {
          if (x.addOn && params.addOn) {
            addOnFlag = compareAddOns(x.addOn, params.addOn) ? false : true;
          }
          if (x.customisationPreferences && params.customisationPreferences) {
            preferenceFlag = comparePreferences(
              x.customisationPreferences,
              params.customisationPreferences
            )
              ? false
              : true;
          }
          if (addOnFlag || preferenceFlag) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      });
      setCookie("cart", JSON.stringify(cart), {
        path: "/",
      });
    }
  }

  function updateItem(params) {
    let flag = false;
    let addOnFlag = true;
    let preferenceFlag = true;

    if (cart && cart[params.storecode]) {
      cart[params.storecode].items.forEach((x) => {
        if (
          x.itemId === params.productId ||
          params.pVariables?.includes(x.itemId)
        ) {
          flag = true;
          if (x.addOn && params.addOn) {
            addOnFlag = compareAddOns(x.addOn, params.addOn) ? true : false;
          }
          if (x.customisationPreferences && params.customisationPreferences) {
            preferenceFlag = comparePreferences(
              x.customisationPreferences,
              params.customisationPreferences
            )
              ? true
              : false;
          }
          if (addOnFlag && preferenceFlag) {
            flag = true;
          } else {
            flag = false;
          }
          if (flag) {
            x.itemQuantity = params.quantity;
          }
        }
      });
      setCookie("cart", JSON.stringify(cart), {
        path: "/",
      });
    }
  }

  function updateCompleteItem(params) {
    if (cart && cart[params.storecode]) {
      cart[params.storecode].items.forEach((x) => {
        if (x.feGenId === params.item.feGenId) {
          Object.assign(x, params.item);
        }
      });
      setCookie("cart", JSON.stringify(cart), {
        path: "/",
      });
    }
  }

  function updateSelectedAddon(params) {
    if (cart && cart[params.storecode]) {
      cart[params.storecode].items.forEach(
        (x) => x.itemId === params.productId && (x.addOn = params.addOn)
      );
      setCookie("cart", JSON.stringify(cart), {
        path: "/",
      });
    }
  }

  function updateSelectedAttributeList(params) {
    if (cart && cart[params.storecode]) {
      cart[params.storecode].items.forEach((x) => {
        if (x.itemId === params.productId) {
          x.preferences = params.preferences;
          x.customisationPreferences = params.customisationPreferences;
        }
      });
      setCookie("cart", JSON.stringify(cart), {
        path: "/",
      });
    }
  }

  function getCart() {
    return cart;
  }

  function getItem(params) {
    let cItem;
    const storeId = params.storecode;
    let flag = false;
    let addOnFlag = false;
    let preferenceFlag = false;
    if (cart && cart[storeId]) {
      cart[storeId].items.forEach((x) => {
        if (x.itemId === params.productId) {
          flag = true;
          if (x.addOn && params.addOn) {
            addOnFlag = compareAddOns(x.addOn, params.addOn) ? true : false;
          }

          if (x.customisationPreferences && params.customisationPreferences) {
            preferenceFlag = comparePreferences(
              x.customisationPreferences,
              params.customisationPreferences
            )
              ? true
              : false;
          }
          if (addOnFlag && preferenceFlag) {
            flag = true;
          } else {
            flag = false;
          }
          if (flag) {
            cItem = x;
          }
        }
      });
    }
    return cItem;
  }

  function getItems(_obj) {
    let items = [];
    const obj = _obj ? _obj : cart;

    obj && Object.values(obj).forEach((x) => (items = items.concat(x.items)));

    return items;
  }

  function getStoreItems(storeId) {
    return cart && cart[storeId] ? cart[storeId].items : [];
  }

  function isEmpty(_obj) {
    let flag = true;
    const obj = _obj ? _obj : cart;

    if (obj) {
      for (let store in obj) {
        if (obj[store]) {
          0 < obj[store].items.length && (flag = false);
        }
      }
    }

    return flag;
  }

  function hasItem(params) {
    const storeId = params.storecode;
    let flag = false;

    if (cart && cart[storeId]) {
      cart[storeId].items.forEach((x) => {
        if (
          x.itemId === params.productId ||
          params.pVariables?.includes(x.itemId)
        ) {
          flag = true;
          if (x.addOn && params.addOn) {
            flag = compareAddOns(x.addOn, params.addOn) ? true : false;
          }
          if (x.customisationPreferences && params.customisationPreferences) {
            flag = comparePreferences(
              x.customisationPreferences,
              params.customisationPreferences
            )
              ? true
              : false;
          }
        }
      });
    }
    return flag;
  }

  function updateDeliveryOptions(updatedDeliveryOptions) {
    getItems().forEach((x) => (x.deliveryOptions = updatedDeliveryOptions));
    let fulfilmentType = config.productFulfilmentType.takeaway;
    if (
      updatedDeliveryOptions.deliveryOption ===
      config.deliveryOptions.deliveryAtGate
    ) {
      fulfilmentType = config.productFulfilmentType.delivery;
    }
    let localCart = JSON.parse(JSON.stringify(getCart()));
    if (!isEmpty() && Object.values(localCart).length > 0) {
      Object.values(localCart).forEach(
        (x) => (x.fulfilmentType = fulfilmentType)
      );
    }
    this.set(localCart);
    setCookie("cart", JSON.stringify(localCart), {
      path: "/",
    });
  }

  function updateMetaData(terminal, movementType, sector, fulfilmentType) {
    let localCart = JSON.parse(JSON.stringify(getCart()));
    if (!isEmpty() && Object.values(localCart).length > 0) {
      Object.values(localCart).forEach((x) => {
        x.movementType = movementType;
        x.sector = sector;
        x.terminal = terminal;
        x.fulfilmentType = fulfilmentType;
      });
    }
    this.set(localCart);
    setCookie("cart", JSON.stringify(localCart), {
      path: "/",
    });
  }

  let compareTwoArrayOfObjects = (
    first_array_of_objects,
    second_array_of_objects
  ) => {
    return (
      first_array_of_objects &&
      second_array_of_objects &&
      first_array_of_objects.length !== 0 &&
      second_array_of_objects.length !== 0 &&
      first_array_of_objects.length === second_array_of_objects.length &&
      first_array_of_objects.every((element_1) =>
        second_array_of_objects.some((element_2) =>
          Object.keys(element_1).every(
            (key) => element_1[key] === element_2[key]
          )
        )
      )
    );
  };

  const compareAddOns = (result1, result2) => {
    result1.sort(function (a, b) {
      if (a.addonId < b.addonId) {
        return -1;
      }
      if (a.addonId > b.addonId) {
        return 1;
      }
      return 0;
    });
    result2.sort(function (a, b) {
      if (a.addonId < b.addonId) {
        return -1;
      }
      if (a.addonId > b.addonId) {
        return 1;
      }
      return 0;
    });

    if (result1.length !== result2.length) {
      return false;
    } else {
      // let result = result1.filter(
      //   (o1) => !result2.some((o2) => o1.addonId === o2.addonId)
      // );
      // if (result.length > 0) {
      //   return false;
      // } else {
      //   return true;
      // }
      if (JSON.stringify(result1) === JSON.stringify(result2)) {
        return true;
      } else {
        return false;
      }
    }
  };

  const comparePreferences = (result1, result2) => {
    if (result1.length > 0 && "title" in result1[0]) {
      result1.forEach((item) => {
        item.selection.sort((a, b) => {
          if (a._id < b._id) return -1;
          if (a._id > b._id) return 1;
          return 0;
        });
      });

      result1.sort((a, b) => {
        if (a.title < b.title) return -1;
        if (a.title > b.title) return 1;
        return 0;
      });

      result2.forEach((item) => {
        item.selection.sort((a, b) => {
          if (a._id < b._id) return -1;
          if (a._id > b._id) return 1;
          return 0;
        });
      });

      result2.sort((a, b) => {
        if (a.title < b.title) return -1;
        if (a.title > b.title) return 1;
        return 0;
      });
    }

    let result = true;
    if (result1.length !== result2.length) {
      result = false;
    } else {
      // result1?.forEach((x) => {
      //   result2?.forEach((y) => {
      //     if (x.title === y.title) {
      //       result = compareTwoArrayOfObjects(x.selection, y.selection);
      //     } else {
      //       result = true;
      //     }
      //   });
      // });

      result1.forEach((y) => {
        const sortedSel = y.selection.map((z) => {
          const sorted = Object.keys(z)
            .sort()
            .reduce(function (acc, key) {
              acc[key] = z[key];
              return acc;
            }, {});
          return sorted;
        });
        y.selection = sortedSel;
      });

      result2.forEach((y) => {
        const sortedSel = y.selection.map((z) => {
          const sorted = Object.keys(z)
            .sort()
            .reduce(function (acc, key) {
              acc[key] = z[key];
              return acc;
            }, {});
          return sorted;
        });
        y.selection = sortedSel;
      });

      if (JSON.stringify(result1) === JSON.stringify(result2)) {
        return true;
      } else {
        return false;
      }
    }
    return result;
  };

  const removeItemById = (params) => {
    const storeId = params.storecode;
    const productId = params.productId;
    cart[storeId].items = cart[storeId].items.filter(
      (x) => x.itemId !== productId && !params.pVariables?.includes(x.itemId)
    );
    setCookie("cart", JSON.stringify(cart), {
      path: "/",
    });
  };

  // ------------------------------------------ NEW -------------------------------------------------------

  function isAlreadyAdded(params) {
    const storeId = params.storeId;

    if (cart && cart[storeId]) {
      const items = cart[storeId].items;

      const isAddOnPreferencesAvailable =
        params.addOn !== undefined ||
        params.customisationPreferences !== undefined;

      let variablesMatched = false;

      for (const item of items) {
        if (params?.item?.pVariables) {
          variablesMatched = params.item.pVariables.includes(item.itemId);
        }
        if (isAddOnPreferencesAvailable) {
          if (variablesMatched || item.itemId === params.productId) {
            let addOnMatched = false;
            let customisationPreferencesMatched = false;
            if (params.addOn && item.addOn) {
              addOnMatched = compareArrayOfObjects(item.addOn, params.addOn);
            }
            if (
              params.customisationPreferences &&
              item.customisationPreferences
            ) {
              customisationPreferencesMatched = compareArrayOfObjects(
                params.customisationPreferences,
                item.customisationPreferences
              );
            }
            if (addOnMatched && customisationPreferencesMatched) {
              return true;
            } else {
              return false;
            }
          }
        } else {
          if (variablesMatched || item.itemId === params.productId) {
            return true;
          }
        }
      }
      return false;
    }
  }

  // Used in Cart Only
  function isPresentInCart(params) {
    const storeId = params.storeId;

    if (cart && cart[storeId]) {
      const items = cart[storeId].items;

      for (const item of items) {
        if (
          item.itemId === params.productId &&
          compareArrayOfObjects(item.addOn, params.addOn) &&
          compareArrayOfObjects(
            item.customisationPreferences,
            params.customisationPreferences
          )
        ) {
          return true;
        }
      }
      return false;
    }
  }

  function updateProductItem(params) {
    let addOnUpdated = false;
    let preferenceUpdated = false;

    let updateAddOnPreferences =
      params.addOn !== undefined ||
      params.customisationPreferences !== undefined;

    if (cart && cart[params.storeId]) {
      const items = cart[params.storeId].items;
      let matchingItems;
      if (params?.pVariables?.length > 0 && params?.pVariables !== undefined) {
        matchingItems = items.filter((item) =>
          params?.pVariables.includes(item.itemId)
        );
      } else {
        matchingItems = items.filter(
          (item) => item.itemId === params.productId
        );
      }

      if (updateAddOnPreferences) {
        for (const item of items) {
          let variablesMatched = false;
          if (params?.item?.pVariables) {
            variablesMatched = params.item.pVariables.includes(item.itemId);
          }

          const addOnMatched = compareArrayOfObjects(
            item.addOn,
            params.item.addOn || []
          );
          const customisationPreferencesMatched = compareArrayOfObjects(
            item.customisationPreferences,
            params.item.customisationPreferences || []
          );

          if (
            (variablesMatched || item.itemId === params.productId) &&
            addOnMatched &&
            customisationPreferencesMatched
          ) {
            if (item.addOn && params.addOn && params.item.addOn) {
              addOnUpdated = compareArrayOfObjects(item.addOn, params.addOn)
                ? false
                : true;
            }
            if (
              item.customisationPreferences &&
              params.customisationPreferences &&
              params.item.customisationPreferences
            ) {
              preferenceUpdated = compareArrayOfObjects(
                item.customisationPreferences,
                params.customisationPreferences
              )
                ? false
                : true;
            }
            if (addOnUpdated) {
              item.addOn = params.addOn;
            }
            if (preferenceUpdated) {
              item.customisationPreferences = params.customisationPreferences;
            }
            if (!addOnUpdated || !preferenceUpdated) {
              if (params.quantity <= 0) {
                const index = items.indexOf(item);
                items.splice(index, 1);
                cart[params.storeId].items = items;
                if (items.length === 0) {
                  delete cart[params.storeId];
                }
              } else {
                item.itemQuantity = params.quantity;
              }
            }
          }
        }
      } else {
        for (const item of matchingItems) {
          let variablesMatched = false;
          if (
            params?.pVariables?.length > 0 &&
            params?.pVariables !== undefined
          ) {
            variablesMatched = params.pVariables.includes(item.itemId);
          }
          if (variablesMatched) {
            if (params.quantity <= 0) {
              items.pop();
              cart[params.storeId].items = items;
              if (items.length === 0) {
                delete cart[params.storeId];
              }
              this.set(cart);
              setCookie("cart", JSON.stringify(cart), {
                path: "/",
              });
              return;
            } else {
              matchingItems[matchingItems.length - 1].itemQuantity =
                params.quantity;
            }
          } else if (item.itemId === params.productId) {
            if (params.quantity <= 0) {
              const index = items.indexOf(item);
              items.splice(index, 1);
              cart[params.storeId].items = items;
              if (items.length === 0) {
                delete cart[params.storeId];
              }
            } else {
              item.itemQuantity = params.quantity;
            }
          }
        }
      }
      this.set(cart);
      setCookie("cart", JSON.stringify(cart), {
        path: "/",
      });
    }
  }

  function updateRepatedItem(params) {
    let updated = false;
    let addOnUpdated = false;
    let preferenceUpdated = false;
    if (cart && cart[params.storeId]) {
      cart[params.storeId].items.forEach((x) => {
        const addOnMatched = compareArrayOfObjects(x.addOn, params.item.addOn);
        const customisationPreferencesMatched = compareArrayOfObjects(
          x.customisationPreferences,
          params.item.customisationPreferences
        );

        if (
          x.itemId === params.productId &&
          addOnMatched &&
          customisationPreferencesMatched
        ) {
          updated = false;
          if (x.addOn && params.item.addOn) {
            if (x.addOn && params.addOn) {
              addOnUpdated = compareArrayOfObjects(x.addOn, params.addOn)
                ? false
                : true;
            }
          }
          if (
            x.customisationPreferences &&
            params.item.customisationPreferences &&
            customisationPreferencesMatched
          ) {
            if (x.customisationPreferences && params.customisationPreferences) {
              preferenceUpdated = compareArrayOfObjects(
                x.customisationPreferences,
                params.customisationPreferences
              )
                ? false
                : true;
            }
          }
          if (addOnUpdated) {
            x.addOn = params.addOn;
          }
          if (preferenceUpdated) {
            x.customisationPreferences = params.customisationPreferences;
            if (params.preferences !== undefined) {
              x.preferences = params.preferences;
            }
          }
          if (addOnUpdated || preferenceUpdated) {
            updated = true;
          } else {
            updated = false;
          }
          if (updated) {
            if (params.quantity <= 0) {
              removeProductItem(params);
            } else {
              x.itemQuantity = params.quantity;
            }
          }
        }
      });
      this.set(cart);
      setCookie("cart", JSON.stringify(cart), {
        path: "/",
      });
    }
  }

  function removeProductItem(params) {
    const storeId = params.storeId;
    let addOnFlag = false;
    let preferenceFlag = false;

    if (cart && cart[storeId]) {
      cart[storeId].items = cart[storeId].items.filter((x) => {
        if (x.itemId === params.productId) {
          if (x.addOn && params.addOn) {
            addOnFlag = compareArrayOfObjects(x.addOn, params.addOn)
              ? false
              : true;
          }
          if (
            x.customisationPreferences > 0 &&
            params.customisationPreferences > 0
          ) {
            preferenceFlag = compareArrayOfObjects(
              x.customisationPreferences,
              params.customisationPreferences
            )
              ? false
              : true;
          }
          if (addOnFlag || preferenceFlag) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      });
      this.set(cart);
      setCookie("cart", JSON.stringify(cart), {
        path: "/",
      });
    }
  }

  function getItemQunatity(params) {
    let qty;
    const storeId = params.storeId;
    let flag = false;
    let addOnFlag = true;
    let preferenceFlag = true;
    if (cart && cart[storeId]) {
      cart[storeId].items.forEach((x) => {
        let variablesMatched = false;
        if (params?.item?.pVariables) {
          variablesMatched = params.item.pVariables.includes(x.itemId);
        }
        if (variablesMatched || x.itemId === params.productId) {
          flag = true;
          if (x.addOn && params.addOn) {
            addOnFlag = compareArrayOfObjects(x.addOn, params.addOn)
              ? true
              : false;
          }
          if (x.customisationPreferences && params.customisationPreferences) {
            preferenceFlag = compareArrayOfObjects(
              x.customisationPreferences,
              params.customisationPreferences
            )
              ? true
              : false;
          }
          if (addOnFlag && preferenceFlag) {
            flag = true;
          } else {
            flag = false;
          }
          if (flag) {
            qty = x.itemQuantity;
          }
        }
      });
    }
    return qty;
  }

  const compareArrayOfObjects = (arr1, arr2) => {
    arr1.sort(function (a, b) {
      if (a.addonId < b.addonId) {
        return -1;
      }
      if (a.addonId > b.addonId) {
        return 1;
      }
      return 0;
    });
    arr2.sort(function (a, b) {
      if (a.addonId < b.addonId) {
        return -1;
      }
      if (a.addonId > b.addonId) {
        return 1;
      }
      return 0;
    });

    if (arr1.length > 0 && "title" in arr1[0]) {
      arr1.forEach((item) => {
        item.selection.sort((a, b) => {
          if (a._id < b._id) return -1;
          if (a._id > b._id) return 1;
          return 0;
        });
      });

      arr1.sort((a, b) => {
        if (a.title < b.title) return -1;
        if (a.title > b.title) return 1;
        return 0;
      });

      arr2.forEach((item) => {
        item.selection.sort((a, b) => {
          if (a._id < b._id) return -1;
          if (a._id > b._id) return 1;
          return 0;
        });
      });

      arr2.sort((a, b) => {
        if (a.title < b.title) return -1;
        if (a.title > b.title) return 1;
        return 0;
      });
    }

    if (arr1.length !== arr2.length) {
      return false;
    } else {
      if (JSON.stringify(arr1) === JSON.stringify(arr2)) {
        return true;
      } else {
        return false;
      }
    }
  };

  const saveCart = async (checkoutObj) => {
    if (isLoggedIn()) {
      try {
        let apiURL = `${apiList?.cart?.saveCart}?type=kiosk`;
        let apiResponse = await callApi.post(apiURL, checkoutObj);
        return true;
      } catch (e) {
        console.log(e);
        return null;
      }
    }
  };

  const overrideUserSavedCart = async () => {
    if (isLoggedIn()) {
      try {
        let apiURL = `${apiList?.cart?.saveCart}?type=kiosk`;
        let apiResponse = await callApi.post(apiURL, {});
        return true;
      } catch (e) {
        console.log(e);
        return null;
      }
    }
  };

  const myCart = async () => {
    try {
      let obj = {};
      let apiURL = `${apiList?.cart?.myCart}?type=kiosk`;
      let apiResponse = await callApi.get(apiURL);
      if (apiResponse?.status === 200) {
        if (apiResponse?.data?.cart) {
          const data = JSON.parse(apiResponse?.data?.kiosk);
          if (data?.items?.length > 0) {
            data?.items?.forEach((x) => {
              obj[x?.storeId] = x;
            });
            set(obj);
            return getItems(obj);
          } else {
            return {};
          }
        }
      }
    } catch (e) {
      console.log(e);
      return true;
    }
  };

  return (
    <CartContext.Provider
      value={{
        set,
        reset,
        addItem,
        removeItem,
        updateItem,
        updateSelectedAddon,
        updateCompleteItem,
        getCart,
        getItem,
        getItems,
        getStoreItems,
        isEmpty,
        hasItem,
        updateDeliveryOptions,
        updateSelectedAttributeList,
        removeItemById,
        isAlreadyAdded,
        isPresentInCart,
        updateProductItem,
        updateRepatedItem,
        removeProductItem,
        getItemQunatity,
        compareArrayOfObjects,
        updateMetaData,
        saveCart,
        overrideUserSavedCart,
        myCart,
      }}
    >
      {props.children}
    </CartContext.Provider>
  );
};

export { CartProvider, CartContext };
